import { FC } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useMatch } from 'react-router-dom'
import MenuSingleItem from './MenuSingleItem'
import MenuItemWithSubItems from './MenuItemWithSubItems'
import Indicator from '../Indicator'
import { MenuItem } from '../../../_methods'
import { IconWrapper, Text } from '../_styles'

interface MenuItemProps {
  item: MenuItem
  disabled?: boolean
}

const NavMenuItem: FC<MenuItemProps> = ({ item, disabled }) => {
  const { t } = useTranslation()

  const Icon = item.icon
  const isActive = !!useMatch({ path: `${item.link}/`, end: false })
  const badge = item.badge ? useSelector(item.badge) : false

  const content = (
    <>
      <IconWrapper>
        <Icon />
        <Indicator value={badge} />
      </IconWrapper>
      <Text>{t(item.title)}</Text>
    </>
  )

  if (!item.items) {
    return (
      <MenuSingleItem isActive={isActive} link={item.link} disabled={disabled}>
        {content}
      </MenuSingleItem>
    )
  }

  return (
    <MenuItemWithSubItems
      isActive={isActive}
      items={item.items}
      disabled={disabled}
    >
      {content}
    </MenuItemWithSubItems>
  )
}

export default NavMenuItem
